import {transparentize} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

interface ContactNoteActionsProps {
  noteId: number;
  onEditClick: Handler;
  onDeleteClick: Handler;
  onMouseHover: HandlerOf<boolean>;
}

const StyledActionsContainerDiv = styled.div`
  position: absolute;
  right: 8px;
  top: 11px;
  padding-left: 16px;
  background: linear-gradient(
    to right,
    ${(p) => transparentize(1, p.theme.palette.yellow.shade20)} 0%,
    ${(p) => p.theme.palette.yellow.shade20} 16px
  );
  display: flex;
  z-index: 2;
`;

export const ContactNoteActions: FC<ContactNoteActionsProps> = (props) => {
  const theme = useUserTheme();
  const {noteId, onEditClick, onDeleteClick, onMouseHover} = props;

  return (
    <StyledActionsContainerDiv>
      <IconButton
        interactionId={`contact-details-note-${noteId}-edit`}
        iconName="editSmall"
        color={theme.greys.shade70}
        label={<Trans id="contact-details-note-actions-edit">Edit</Trans>}
        onClick={onEditClick}
        onMouseEnter={() => onMouseHover(true)}
        onMouseLeave={() => onMouseHover(false)}
      />
      <IconButton
        interactionId={`contact-details-note-${noteId}-delete`}
        iconName="trashSmall"
        color={theme.greys.shade70}
        label={<Trans id="contact-details-note-actions-delete">Delete</Trans>}
        onClick={onDeleteClick}
        onMouseEnter={() => onMouseHover(true)}
        onMouseLeave={() => onMouseHover(false)}
      />
    </StyledActionsContainerDiv>
  );
};
